import ProseMirrorBoldMark from "./ProseMirrorBoldMark";
import ProseMirrorItalicMark from "./ProseMirrorItalicMark";
import ProseMirrorLinkMark from "./ProseMirrorLinkMark";
import { TYPES } from "./ProseMirrorMarks.constants";

const components = {
  [TYPES.bold]: ProseMirrorBoldMark,
  [TYPES.italic]: ProseMirrorItalicMark,
  [TYPES.link]: ProseMirrorLinkMark,
};

const ProseMirrorMarks = ({ children, marks = [], user = {}, node }) =>
  // Iterates through the marks data and return the children nested within the marks components.
  // e.g. <Mark1><Mark2>{children}</Mark2></Mark1>
  marks.reduce((contentWrappedInMarks, mark) => {
    const Mark = components[mark.type];

    if (!Mark) return contentWrappedInMarks;

    return (
      <Mark user={user} attrs={mark.attrs} node={node}>
        {contentWrappedInMarks}
      </Mark>
    );
  }, children);

export default ProseMirrorMarks;
